import React, { useEffect } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import { mdiAlignVerticalBottom } from "@mdi/js";

import { useInput } from "../../../../../hooks/useInput";
import { Button } from "../../../../../components/Button";
import { useOnChange } from "../../../../../hooks/useOnChange";
import { Checkbox } from "../../../../../components/Checkbox";
import { InputText } from "../../../../../components/InputText";
import { InputNumber } from "../../../../../components/InputNumber";
import calcAreaUtils from "../../../../../../script/utils/calcAreaUtils";

const WorstcaseItemStyle = styled.div`
    >div:nth-child(1) {
        margin-bottom: 10px;
        display: grid;
        grid-template-columns: 2.5fr 1fr 1fr;
        gap: 8px;
        align-items: flex-end;
    }
    >div:nth-child(2) {
        gap: 8px;
        display: flex;
        align-items: flex-end;
        justify-content: end;
    }
`;

export const WorstcaseItem = props => {
    const { calcArea, index, shouldDisplay, onVisibilityChanged, boundaryClipped, onBoundaryClippedChanged, resultDetails, pointAnalysisResultVisible, onPointAnalysisResultVisibleChanged } = props;

    const inputName = "worstcase-result-" + index;
    const initalHeight = calcArea.originZ !== undefined && calcArea.vaxisZ !== undefined ? calcArea.originZ + calcArea.vaxisZ : undefined;

    const areaName = useInput(inputName + "name", calcArea.name);
    const visible = useInput(inputName + "visible", shouldDisplay);
    const boundaryClippedInput = useInput(inputName + "boundaryClipped", boundaryClipped);
    const height = useInput(inputName + "height", initalHeight);
    const heightLow = useInput(inputName + "heightLow", calcArea.originZ);
    const gwaValue = (boundaryClipped ?? false) ? resultDetails?.gwaBoundary : resultDetails?.gwa;
    const gwaValueRounded = gwaValue ? Math.round( gwaValue * 100) / 100 : gwaValue;
    const gwa = useInput(inputName + "gwa", gwaValueRounded);
    const pointAnalysisVisibleInput = useInput(inputName + "pointAnalysisVisible", pointAnalysisResultVisible);

    useOnChange((_, value) => {
        onVisibilityChanged(value);
    }, [visible]);


    useOnChange((_, value) => {
        onBoundaryClippedChanged(value);
    }, [boundaryClippedInput]);

    useEffect(() => {
        const criticalValue = 1.01;
        if(gwa.value !== undefined && gwa.value !== null && gwa.value >= criticalValue) {
            gwa.setError(true);
            gwa.setErrorVisible(true);
        } else {
            gwa.setError(false);
            gwa.setErrorVisible(false);
        }
    }, [gwa.value]);

    useOnChange((_, value) => {
        onPointAnalysisResultVisibleChanged(value);
    }, [pointAnalysisVisibleInput]);

    return (
        <WorstcaseItemStyle>
            <div>
                <InputText {...areaName.bind}
                    disabled={true}
                    maxLength="30"
                    title={intl.get("entry.plan.areas.name")} />
                <div>
                    <InputNumber {...height.bind}
                        title={intl.get("entry.plan.areas.height")}
                        fractionDigits={2}
                        disabled={true} />
                </div>
                <div>
                    <InputNumber {...heightLow.bind}
                        title={intl.get("entry.plan.areas.heightLow")}
                        fractionDigits={2}
                        disabled={true} />
                </div>
            </div>
            <div>
                <div style={{width: "60px", marginRight: "auto"}}>
                    <InputNumber {...gwa.bind}
                        disabled={true}
                        title={intl.get("entry.plan.wattwaechter.gwa")}
                        fractionDigits={2} />
                </div>
                { pointAnalysisResultVisible !== undefined &&
                    <Checkbox {...pointAnalysisVisibleInput.bind}
                        title={intl.get("entry.plan.wattwaechter.pointAnalysisVisible")} />
                }
                <Checkbox {...visible.bind}
                    title={intl.get("entry.plan.worstcase.visible")} />
                <Checkbox {...boundaryClippedInput.bind}
                    disabled={!calcArea.boundary || calcAreaUtils.isVertical(calcArea)}
                    title={intl.get("entry.plan.worstcase.boundaryClipped")} />
                <Button
                    compact
                    svgIcon={mdiAlignVerticalBottom}
                    onClick={props.onResultDialog} />
            </div>
        </WorstcaseItemStyle>
    );
};
